module["exports"] = [
  "Aceh",
  "Sumatera Utara",
  "Sumatera Barat",
  "Jambi",
  "Bangka Belitung",
  "Riau",
  "Kepulauan Riau",
  "Bengkulu",
  "Sumatera Selatan",
  "Lampung",
  "Banten",
  "DKI Jakarta",
  "Jawa Barat",
  "Jawa Tengah",
  "Jawa Timur",
  "Nusa Tenggara Timur",
  "DI Yogyakarta",
  "Bali",
  "Nusa Tenggara Barat",
  "Kalimantan Barat",
  "Kalimantan Tengah",
  "Kalimantan Selatan",
  "Kalimantan Timur",
  "Kalimantan Utara",
  "Sulawesi Selatan",
  "Sulawesi Utara",
  "Gorontalo",
  "Sulawesi Tengah",
  "Sulawesi Barat",
  "Sulawesi Tenggara",
  "Maluku",
  "Maluku Utara",
  "Papua Barat",
  "Papua"
];


//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/address/state.js
// module id = 1523
// module chunks = 0